<template>
  <v-container grid-list-lg>
    <v-row row>
      <v-col cols="12">
        <m-card title="Kelola Profilku" hint="Menu ini berisi informasi dasar profil">
          <v-row wrap>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pr-0">
              <v-img
                src="'https://cdn.siap.id/s3/asset illustrasi/Illustrasi/bg-default.png'"
                min-height="155"
                max-height="200"
                min-width="155"
                max-width="200"
                aspect-ratio="1"
              ></v-img>
              <avatar-cropper
                @uploading="handleUploading"
                @uploaded="handleUploaded"
                @completed="handleCompleted"
                @error="handlerError"
                :cropper-options="{aspectRatio: 1,initialAspectRatio:NaN,cropBoxResizable:true,minCropBoxWidth:50,minCropBoxHeight:50}"
                :output-options="{width: 400}"
                trigger="#pick-avatar"
                :upload-url="urlUploadPhoto"
                :upload-headers="token"
                :upload-form-data="{user_id:this.user.id}"
                :labels="{submit:'Simpan',cancel:'Hapus'}"
              />
            </v-col>
            <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="pl-0">
              <v-card
                flat
                color="primary"
                min-height="200"
                max-height="200"
                :img="user.cover||'img/parallax.png'"
                tile
              >
                <v-list-item three-line>
                  <v-list-item-content class="align-self-start">
                    <v-btn
                      v-if="isCan(`${$consts.ROLE_OWNER.name}|${$consts.ROLE_ADMIN_DESA.name}`)"
                      fab
                      depressed
                      small
                      color="white"
                      style="position: absolute;right: 2px;top: 5px;"
                      id="pick-cover"
                    >
                      <v-icon color="grey">mdi-camera-outline</v-icon>
                    </v-btn>
                    <avatar-cropper
                      @uploading="handleUploading"
                      @uploaded="handleUploaded"
                      @completed="handleCompleted"
                      @error="handlerError"
                      :cropper-options="{aspectRatio: 8/5,initialAspectRatio:NaN,cropBoxResizable:true,minCropBoxWidth:50,minCropBoxHeight:50}"
                      :output-options="{width: 400}"
                      trigger="#pick-cover"
                      :upload-url="urlUploadPhoto"
                      :upload-headers="token"
                      :upload-form-data="{user_id:this.user.id,jenis:'cover'}"
                      :labels="{submit:'Simpan',cancel:'Hapus'}"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-card>
              <!-- <v-divider></v-divider>
              <v-list-item two-line>
                <v-icon class="ma-2" color="green">mdi-shield-check</v-icon>
                <v-list-item-content>
                  <v-list-item-title>Verifikasi Akun</v-list-item-title>
                  <v-list-item-subtitle>{{ user.email_verified_at | toDT }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>-->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4">
              <v-list>
                <v-subheader class="title">Data Pribadi</v-subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>NIP</v-list-item-subtitle>
                    <span class="title">{{ $tools.pVal(user,'nip') }}</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Nama Lengkap</v-list-item-subtitle>
                    <span class="title">{{ $tools.pVal(user,'name') }}</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Jenis Kelamin</v-list-item-subtitle>
                    <v-list-item-title>{{ $tools.pVal(user,'gender') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4">
              <v-list>
                <v-subheader class="title">Data Kontak</v-subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Email</v-list-item-subtitle>
                    <span class="title">{{ $tools.pVal(user,'email') }}</span>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Nomor Telepon</v-list-item-subtitle>
                    <span class="title">{{ $tools.pVal(user,'no_hp') }}</span>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4">
              <v-list>
                <v-subheader class="title">Data User</v-subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Verifikasi Akun</v-list-item-subtitle>
                    <span class="title">{{ $tools.pVal(user,'email_verified_at') }}</span>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Peran</v-list-item-subtitle>
                    <span class="title">{{ $tools.pVal(user,'name') }}</span>
                  </v-list-item-content>
                </v-list-item>-->
              </v-list>
            </v-col>
          </v-row>
        </m-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { API } from "../../../const";

import EditDlg from "../components/Edit.vue";
import AvatarCropper from "vue-avatar-cropper";
export default {
  components: {
    EditDlg,
    AvatarCropper
  },
  data() {
    return {
      message: "",
      token: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`
      },
      urlUploadPhoto: API + "/api/image"
    };
  },
  activated() {
    this.message = "";
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    instansi_aktif() {
      return this.$store.getters["instansi/instansi_aktif"];
    },
    userMeta() {
      return this.$store.getters["user/userMeta"];
    }
  },
  methods: {
    // eslint-disable-next-line
    handleUploading(form, xhr) {
      this.message = "uploading...";
    },
    // eslint-disable-next-line
    handleUploaded(response) {
      if (response) {
        this.$store
          .dispatch("user/profil")
          .then(() => {})
          .catch(e => e);
        // this.userData.avatar = response.url;
        // Maybe you need call vuex action to
        // update user avatar, for example:
        // this.$dispatch('updateUser', {avatar: response.url})
      }
    },
    // eslint-disable-next-line
    handleCompleted(response, form, xhr) {
      this.$info("Update Foto Berhasil");
      this.message = "";
      // return this.$store.dispatch('user/fetch')
    },
    // eslint-disable-next-line
    handlerError(message, type, xhr) {
      this.$error("Update Foto Gagal");
      this.message = "Oops! Something went wrong...";
    },
    edit() {
      this.$refs.dlg.open().catch(e => e);
    }
  },
  watch: {}
};
</script>
